import classnames from 'classnames/bind'
import { GlobalThemeColors } from '~/@types/colors'
import type { Variant } from '~/@types/product'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { ArrowSelectIcon } from '~/components/Icons'
import AddToCartButton, { CartItem } from '~/components/UI/AddToCartButton'
import { ProductStickyCtaProps } from '~/components/UI/ProductHeader/ProductStickyCta'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

interface ProductActionProps {
  variants?: Variant[]
  active?: boolean
  selectedVariant?: Variant
  price?: string
  cartItems?: CartItem[]
  crossedOutPrice?: string
  isGiftCard?: boolean
  onClick?: () => void
  handleAddToCart?: ProductStickyCtaProps['handleAddToCart']
  hasOnlyAddToCartButton?: boolean
}

function ProductAction({
  variants,
  active,
  selectedVariant,
  price,
  cartItems,
  crossedOutPrice,
  onClick,
  handleAddToCart,
  isGiftCard,
  hasOnlyAddToCartButton,
}: ProductActionProps) {
  const selectStyle = useStyle({
    textPreset: GlobalTextPreset.Label12Haffer,
    color: GlobalThemeColors.Black,
    textStyling: GlobalTextStyling.UpperCase,
  })

  if (!variants?.length) return null

  return (
    <div className={css.ProductAction}>
      {!hasOnlyAddToCartButton && (
        <div className={cx(css.variantSelect)} onClick={onClick}>
          <div className={cx(css.variantInput, selectStyle)}>
            <span>{selectedVariant?.title}</span>
            <ArrowSelectIcon
              fill="#000000"
              className={cx(css.selectIcon, { active })}
            />
          </div>
        </div>
      )}

      <AddToCartButton
        className={cx(css.addToCart, { hasOnlyAddToCartButton })}
        disabled={!price}
        price={price}
        textPreset={GlobalTextPreset.Cta12Haffer}
        cartItems={cartItems}
        onAdded={handleAddToCart}
        crossedOutPrice={crossedOutPrice}
        isGiftCard={isGiftCard}
      />
    </div>
  )
}

export default ProductAction
